import { Link } from "react-router-dom";

const FRIEND_LINKS = [
  "影视资源网",
  "追剧指南",
  "电影资讯",
  "综艺观察",
  "热播榜单",
];

const CATEGORY_LINKS = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-500 text-background-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold">污视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100">
              污视频是以内容聚合为核心的视频娱乐平台，汇聚电影、电视剧、综艺等热门资源，帮助你在海量内容中快速发现感兴趣的作品。本站仅提供视频资源信息展示，不提供播放与下载功能。
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-primary-100">
              浏览分类
            </h4>
            <ul className="mt-4 space-y-2.5">
              {CATEGORY_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-100 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-primary-100">
              友情链接
            </h4>
            <ul className="mt-4 space-y-2.5">
              {FRIEND_LINKS.map((name) => (
                <li key={name}>
                  <span className="cursor-default text-sm text-primary-100 transition-colors hover:text-accent-300">
                    {name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-3 border-t border-primary-400/40 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 污视频 · 本站内容均为演示数据，仅供浏览参考</p>
          <p>本站不提供任何视频播放与下载服务</p>
        </div>
      </div>
    </footer>
  );
}